<div *transloco="let t; prefix: scope" class="flex flex-col gap-4">
  <p class="font-semibold">{{ t('subTitle') }}</p>

  <div [formGroup]="formGroup" pFocusTrap>
    @if (isAnnualSubscription) {
      <!-- Use a dropdown with the firm users when subsdcription is Annual -->
      <div class="flex flex-col mt-4">
        <label class="font-medium" for="selectuser">* {{ t('selectUserLabel') }}</label>
        <app-user-selector
          name="selectuser"
          *ngIf="isAnnualSubscription"
          [includeAllItem]="false"
          [placeholder]="t('selectUserLabel')"
          styleClass="w-full"
          (userIdChange)="onUserSelected($event)">
        </app-user-selector>
      </div>
    }

    @if (!isAnnualSubscription) {
      <div class="flex flex-col mt-4">
        <label for="name">* {{ t('nameLabel') }}</label>
        <bl-frontend-text-input name="name" formControlName="name" class="w-full"></bl-frontend-text-input>
      </div>

      <div class="flex flex-col mt-4">
        <label for="email">* {{ t('emailLabel') }}</label>
        <bl-frontend-text-input name="email" formControlName="email" class="w-full"></bl-frontend-text-input>
      </div>
    }

    <div class="flex flex-col mt-4" *ngIf="isSwedishFirm">
      <label for="socialSecurityNumber"
        >* {{ t('socialSecurityNumberLabel') }}
        <span class="text-sm font-normal text-gray-500">({{ t('format') }}: YYYYMMDDXXXX)</span></label
      >
      <bl-frontend-text-input
        name="socialSecurityNumber"
        formControlName="socialSecurityNumber"
        (blurEvent)="onSocialSecurityNumberBlur()" />
    </div>
    <div class="flex flex-col mt-4" *ngIf="!isSwedishFirm">
      <label for="phoneNumber">* {{ t('phoneNumberLabel') }}</label>
      <bl-frontend-text-input name="phoneNumber" formControlName="phoneNumber" class="w-full"></bl-frontend-text-input>
    </div>

    <bl-frontend-alert
      class="block mt-4"
      *ngIf="errorMessage()"
      header="Error"
      [content]="errorMessage()"
      severity="danger">
    </bl-frontend-alert>
  </div>

  <div class="flex justify-end mt-6">
    <bl-frontend-button
      class="mr-2"
      [text]="'shared.cancel' | transloco"
      variant="secondary"
      (onclick)="close(null)"></bl-frontend-button>
    <bl-frontend-button
      [text]="'shared.save' | transloco"
      variant="primary"
      [disabled]="!isValid"
      (onclick)="saveAndCreateAdmin()"></bl-frontend-button>
  </div>
</div>
